import script from "./FormSelectOfficeSchedule.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormSelectOfficeSchedule.vue?vue&type=script&lang=ts&setup=true"

import "./FormSelectOfficeSchedule.vue?vue&type=style&index=0&id=23fb4608&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23fb4608"]])

export default __exports__